import { useNavigate } from 'react-router-dom';

import { queryClient } from '../../app/query-client';
import { useAuth } from '../../auth/AuthProvider';
import { Route42Logo } from '../brand/Route42Logo';
import { Sidebar } from './Sidebar';
import type { RecentWorkItem } from './recent-work';

export function MobileNavigation({
  machineId,
  machineName,
  onClose,
  canViewOrganization = false,
  canViewUsers = false,
  canSwitchOrganization = false,
  recentWork = [],
}: {
  machineId: string | null;
  machineName: string | null;
  canViewOrganization?: boolean;
  canViewUsers?: boolean;
  canSwitchOrganization?: boolean;
  recentWork?: RecentWorkItem[];
  onClose: () => void;
}) {
  const auth = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    queryClient.clear();
    await auth.signOut();
    onClose();
    navigate('/sign-in', { replace: true });
  }

  return (
    <div className="r42-mobile-nav-layer" role="dialog" aria-modal="true" aria-label="Navigation">
      <button className="r42-mobile-nav-backdrop" onClick={onClose} aria-label="Close navigation" />
      <div className="r42-mobile-nav-panel">
        <div className="r42-mobile-nav-head">
          <Route42Logo variant="lockup" />
          <button className="r42-icon-button" onClick={onClose} aria-label="Close navigation">
            <i className="bi bi-x-lg" aria-hidden="true" />
          </button>
        </div>
        <div className="r42-mobile-nav-content" onClick={onClose}>
          <Sidebar machineId={machineId} machineName={machineName} canViewOrganization={canViewOrganization} canViewUsers={canViewUsers} canSwitchOrganization={canSwitchOrganization} recentWork={recentWork} />
        </div>
        <div className="r42-mobile-nav-footer">
          <button className="r42-mobile-nav-signout" type="button" onClick={() => void handleSignOut()}>
            <i className="bi bi-box-arrow-right" aria-hidden="true" />
            <span>Sign out</span>
          </button>
        </div>
      </div>
    </div>
  );
}
